import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sun, Moon, ArrowLeft } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { SITE } from '../../config/site';
import { trackEvent } from '../../utils/analytics';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const { isDarkMode, toggleTheme } = useTheme();
    const location = useLocation();
    const isHome = location.pathname === '/';

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                isScrolled
                    ? 'h-16 bg-white/70 dark:bg-slate-950/70 backdrop-blur-glass border-b border-white/30 dark:border-white/[0.06] shadow-lg shadow-slate-900/5 dark:shadow-black/20'
                    : 'h-20 bg-white/40 dark:bg-slate-950/40 backdrop-blur-sm'
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 group"
                    onClick={() => trackEvent('logo_click', 'navigation', 'header')}
                >
                    <img src={SITE.logo} alt={SITE.shortName} className="w-8 h-8 dark:invert" />
                    <span className="font-bold text-xl text-slate-900 dark:text-white">{SITE.shortName}</span>
                </Link>

                <nav className="flex items-center gap-1">
                    {!isHome && (
                        <Link
                            to="/"
                            className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-white/50 dark:hover:bg-white/[0.06] hover:text-slate-900 dark:hover:text-white transition-all"
                        >
                            <ArrowLeft className="w-4 h-4" />
                            Tất cả ứng dụng
                        </Link>
                    )}
                    <button
                        onClick={toggleTheme}
                        className="p-2 rounded-lg text-slate-600 dark:text-slate-300 hover:bg-white/50 dark:hover:bg-white/[0.06] hover:text-slate-900 dark:hover:text-white transition-all"
                        aria-label="Đổi giao diện sáng/tối"
                    >
                        {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
                    </button>
                </nav>
            </div>
        </header>
    );
};

export default Header;
